import { Controller } from "stimulus"
import $ from "jquery"

// Stimulus controller for the unified license enrollment modal
// Handles populating product ID from trigger buttons and managing modal state
export default class extends Controller {
  static targets = ["form", "productId", "productTitle", "contactId", "productIdSelect"]

  connect() {
    // Listen for modal show event to populate product details from trigger button
    $(this.element).on('show.bs.modal', this.handleShow.bind(this))

    // Listen for modal hide event to clean up form
    $(this.element).on('hidden.bs.modal', this.handleHidden.bind(this))

    // Listen for product dropdown changes (when products list is provided)
    if (this.hasProductIdSelectTarget) {
      this.productIdSelectTarget.addEventListener('change', this.syncProductId.bind(this))
    }
  }

  disconnect() {
    // Clean up event listeners
    $(this.element).off('show.bs.modal')
    $(this.element).off('hidden.bs.modal')

    if (this.hasProductIdSelectTarget) {
      this.productIdSelectTarget.removeEventListener('change', this.syncProductId.bind(this))
    }
  }

  handleShow(event) {
    // Get the button that triggered the modal
    const button = event.relatedTarget

    if (!button) return

    // Get product details from data attributes on trigger button
    const productId = button.dataset.productId
    const productTitle = button.dataset.productTitle

    // Populate product ID in hidden field (if product is pre-selected from catalog)
    if (productId && this.hasProductIdTarget) {
      this.productIdTarget.value = productId
    }

    // Update modal title with product name (if provided)
    if (productTitle && this.hasProductTitleTarget) {
      this.productTitleTarget.textContent = `Enroll Contact in ${productTitle}`
    }
  }

  handleHidden() {
    // Reset form when modal is closed
    if (this.hasFormTarget) {
      this.formTarget.reset()

      // Clear the modal alerts turbo frame
      const alertsFrame = document.getElementById('modal_alerts')
      if (alertsFrame) {
        alertsFrame.innerHTML = ''
      }

      // Reset product ID hidden field
      if (this.hasProductIdTarget) {
        this.productIdTarget.value = ''
      }

      // Reset contact search if it exists
      const contactSearchSelect = this.element.querySelector('.contact-search-select')
      if (contactSearchSelect) {
        $(contactSearchSelect).val('').trigger('change')

        // Clear the autocomplete custom input if it exists
        const searchInput = this.element.querySelector('.contact-search-input')
        if (searchInput) {
          searchInput.value = ''
          searchInput.classList.remove('is-valid', 'is-invalid')
        }
      }

      // Clear any validation states
      const formControls = this.element.querySelectorAll('.form-control')
      formControls.forEach(control => {
        control.classList.remove('is-valid', 'is-invalid')
      })
    }
  }

  // Sync product dropdown selection to hidden field (for contact show page)
  syncProductId(event) {
    if (this.hasProductIdTarget) {
      this.productIdTarget.value = event.target.value
    }
  }

  // Method to close modal (can be called from Turbo Stream or other controllers)
  close() {
    $(this.element).modal('hide')
  }
}

